import { useContext } from 'react';
import { OutboundCallModalContext } from './OutboundCallModalContext';

export const useOutboundCallModalContext = () => {
  const context = useContext(OutboundCallModalContext);
  if (context === undefined) {
    throw new Error(
      'useOutboundCallModalContext must be used within a OutboundCallModalProvider',
    );
  }
  return context;
};
